var Model = require('../Model');
var model = Object.create(Model);

function normalizeBottleneck(value) {
  return value === 'BacnetDevice' ? 'BacnetDevice' : '';
}

function normalizeTrafficProfile(value, record) {
  if (!hasOwn(record, 'trafficHandlingProfile')) return undefined;
  var normalized = String(value || '').trim().toLowerCase();
  return ['protected', 'balanced', 'custom', 'legacy'].indexOf(normalized) >= 0
    ? normalized
    : 'balanced';
}

function normalizeBoundedNumber(value, fallback, minimum, maximum) {
  if (isBlank(value)) return fallback;
  var number = Number(value);
  if (!Number.isFinite(number)) return fallback;
  return Math.min(maximum, Math.max(minimum, Math.round(number)));
}

function normalizeTransport(value) {
  return value === 'bacnet-sc' ? 'bacnet-sc' : 'bacnet-ip';
}

function normalizeScConnection(value) {
  if (isBlank(value)) return null;
  if (value && value['@rid']) return value['@rid'].toString();
  var text = String(value).trim();
  return text.charAt(0) === '#' ? text : '#' + text;
}

function normalizeTargetVmac(value) {
  if (isBlank(value)) return '';
  return String(value).trim().replace(/[:-]/g, '').toLowerCase();
}

function isBlank(value) {
  return value === undefined || value === null || String(value).trim() === '';
}

function hasOwn(record, key) {
  return !!record && Object.prototype.hasOwnProperty.call(record, key);
}

function normalizePortValue(value) {
  if (isBlank(value)) return null;
  var number = Number(value);
  return Number.isFinite(number) ? number : value;
}

function normalizeDestinationPort(value, record) {
  if (!isBlank(value)) return normalizePortValue(value);
  if (hasOwn(record, 'port') && !isBlank(record.port)) {
    return normalizePortValue(record.port);
  }
  if (hasOwn(record, 'destinationPort')) return null;
  return undefined;
}

function normalizeLegacyPort(value, record) {
  return hasOwn(record, 'port') ? null : undefined;
}

model.name = 'BACnet Host';
model['@class'] = 'BacnetServer';
model.url = 'bacnetserver';
model.parentClass = 'Host';
model.isNetworkModel = true;
model.fields = {
  enabled: {
    type: 'switch',
    default: 0,
  },
  name: {
    type: 'text',
    default: null,
  },
  transport: {
    type: 'select',
    default: 'bacnet-ip',
    normalize: normalizeTransport,
  },
  host: {
    type: 'text',
    default: null,
  },
  scConnection: {
    type: 'select',
    default: null,
    normalize: normalizeScConnection,
  },
  targetVmac: {
    type: 'text',
    default: '',
    normalize: normalizeTargetVmac,
  },
  destinationPort: {
    type: 'text',
    default: null,
    normalize: normalizeDestinationPort,
  },
  port: {
    type: 'text',
    default: null,
    hidden: true,
    normalize: normalizeLegacyPort,
  },
  error: {
    default: null,
  },
  status: {
    default: 'unknown',
  },
  bottleneck: {
    type: 'select',
    default: '',
    hidden: true,
    options: [
      { name: 'Host (default)', value: '' },
      { name: 'BACnet Device', value: 'BacnetDevice' },
    ],
    normalize: normalizeBottleneck
  },
  trafficHandlingProfile: {
    type: 'select',
    default: 'balanced',
    hidden: true,
    normalize: normalizeTrafficProfile,
  },
  routingDomain: {
    type: 'text',
    default: '',
    hidden: true,
  },
  trafficConcurrentDownstreamNetworks: {
    type: 'number',
    default: 2,
    hidden: true,
    normalize: function (value, record) {
      return hasOwn(record, 'trafficConcurrentDownstreamNetworks')
        ? normalizeBoundedNumber(value, 2, 1, 16) : undefined;
    },
  },
  trafficRequestSpacingMs: {
    type: 'number',
    default: 250,
    hidden: true,
    normalize: function (value, record) {
      return hasOwn(record, 'trafficRequestSpacingMs')
        ? normalizeBoundedNumber(value, 250, 0, 60000) : undefined;
    },
  },
  trafficFailureBaseDelayMs: {
    type: 'number',
    default: 5000,
    hidden: true,
    normalize: function (value, record) {
      return hasOwn(record, 'trafficFailureBaseDelayMs')
        ? normalizeBoundedNumber(value, 5000, 250, 300000) : undefined;
    },
  },
  trafficFailureMaxDelayMs: {
    type: 'number',
    default: 300000,
    hidden: true,
    normalize: function (value, record) {
      if (!hasOwn(record, 'trafficFailureMaxDelayMs')) return undefined;
      var minimum = normalizeBoundedNumber(record.trafficFailureBaseDelayMs, 5000, 250, 300000);
      return normalizeBoundedNumber(value, 300000, minimum, 3600000);
    },
  },
  trafficTimeoutMs: {
    type: 'number',
    default: 15000,
    hidden: true,
    normalize: function (value, record) {
      return hasOwn(record, 'trafficTimeoutMs')
        ? normalizeBoundedNumber(value, 15000, 1000, 120000) : undefined;
    },
  },
  trafficWhoIsMinIntervalMs: {
    type: 'number',
    default: 60000,
    hidden: true,
    normalize: function (value, record) {
      return hasOwn(record, 'trafficWhoIsMinIntervalMs')
        ? normalizeBoundedNumber(value, 60000, 10000, 3600000) : undefined;
    },
  },
};

module.exports = model;
